import request from '@/common/request'

class FornecedorService {
  getAll() {
    return request.get('/fornecedores')
  }

  create(data) {
    return request.post('/fornecedores', data)
  }

  update(id, data) {
    return request.patch(`/fornecedores/${id}`, data)
  }

  deleteById(id) {
    return request.delete(`/fornecedores/${id}`)
  }
}

export default new FornecedorService()
